import { MenuItemIcon } from '@/components/MenuItem/MenuItemIcon';
import Lock from '@/images/Lock.svg';
import { useAdvancedEditorContext } from '@/pages/AdvancedEditor/context/useAdvancedEditorContext';
import { lockElements } from '../../actions/Lock';

interface Props {
    closeMenu: () => void;
}

export const LockMenuItem = ({ closeMenu }: Props) => {
    const { store } = useAdvancedEditorContext();
    const selectedElements = store.selectedElements;

    const handleClick = () => {
        closeMenu();
        lockElements(selectedElements);
    };

    return <MenuItemIcon onClick={handleClick} src={Lock} text="Lock" />;
};
